<button mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon>{{ menuIcon ?? 'person_outlined' }}</mat-icon>
</button>
<mat-menu #menu="matMenu" xPosition="before">
  <div mat-menu-item [disableRipple]="true">
    <div class="px-1 pt-2 pb-4 w-56">
      <div class="font-bold">{{ resolvedName }}</div>
      <div>{{ resolvedUsername }}</div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <ng-content></ng-content>
  <button mat-menu-item (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Log out</span>
  </button>
</mat-menu>
